export const formatWeeks = (value) => {
    if (typeof (value) == 'string') {
        return value?.includes("+") ? (() => {
            const [weeks, days] = value.split("+");
            return `${weeks =="null"? "0": weeks||''} wk ${days} dy`;
        })() : '-'
    }
    else if (typeof (value) == 'number') {
        return `${value||''} wk ${0} dy`
    }
}